import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup'
import Badge from 'react-bootstrap/Badge'
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import * as MySound from '../MySound';
import ModalOK from './CartonisedModalOk';
import ModalYesNo from './CartonisedModalYesNo';

export class CartonisedUnknownCarton extends Component {

    static displayName = CartonisedUnknownCarton.name;
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            alertMessage: "",
            selectedShipment: props.location.state.selectedShipment,
            unknownCartons: [],
            filteredUnknownCartons: [],
            toggleSSCCContent: false,
            selectedSSCCForItemScan: "",
            scannedSSCCUnknownCarton: "",
            ssccScannedItemsList: [],
            errorAlert: false,
            errorAlertMsg: '',
            alertReset: false

        };
        this.history = props.history;

    }
    componentDidMount() {
        if (this.state.selectedShipment.hasXDock) {
            this.goto('CartonisedSupervisorSignoff', { backUrl: 'CartonisedChooseShipment', nextUrl: 'CartonisedConfirmInwards', selectedShipment: this.state.selectedShipment });
        }
        else {
            this.getUnknownCartonsForShipment();
        }
       
    }

    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : "";

        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        const handleSearchInput = e => {
            var searchText = e.target.value;
            var filteredItems = this.state.unknownCartons.filter(function (item) {
                return item.sscc.toUpperCase().indexOf(searchText.toUpperCase()) > -1;
            });
            this.setState({ filteredUnknownCartons: filteredItems });
        };

        const handleSSCCItembarcodeScanKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.addSSCCItemBarcodesToList(e.target.value);
                e.target.value = "";
            }
        };

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        var parent = this;
        return (
            <>
                {alertMessage}
                <MyHeading>Unknown Cartons</MyHeading>
                {contents}
                {!this.state.toggleSSCCContent && this.state.unknownCartons.length > 0 && <>
                    <Row >
                        <Col>
                            <input autoFocus="autofocus" className="filter form-control" onInput={handleSearchInput} type="text" placeholder="Scan unknown carton SSCC..."
                                value={this.state.scannedSSCCUnknownCarton}
                                ref="ssccCartonBarcodeInput"
                                onKeyPress={(e) => {
                                    if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                                        this.findUnknownCarton();
                                    }
                                }}
                                onChange={(e) => {
                                    this.setState({ scannedSSCCUnknownCarton: e.target.value });
                                }} />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col>
                            <ListGroup >
                                {this.state.filteredUnknownCartons.map(function (item) {
                                    var child = parent;
                                    return (<ListGroup.Item key={item.sscc}>
                                        <div className="col-12 float-left" variant="link" onClick={() => child.setState({ toggleSSCCContent: true, selectedSSCCForItemScan: item.sscc })}>{item.sscc} <span className="float-right">{item.content_count}</span></div>
                                    </ListGroup.Item>);
                                })}
                            </ListGroup>
                        </Col>
                    </Row>
                </>}
                {this.state.toggleSSCCContent && this.state.unknownCartons.length > 0 && <>
                    <Row className="mt-2">
                        <Col >
                            Please scan item content of SSCC
                        </Col>
                    </Row>
                    <Row className="mt-1">
                        <Col className="col-4">
                            SSCC:
                        </Col>
                        <Col className="col-8">
                            {this.state.selectedSSCCForItemScan}
                        </Col>
                    </Row>
                    <Row className="mt-1">
                        <Col className="col-4">
                            Scan Barcode:
                        </Col>
                        <Col className="col-8">
                            <input autoFocus="autofocus" type="text" className="form-control mb-2" placeholder="Scan item barcode..." onKeyPress={handleSSCCItembarcodeScanKeyPress} onInput={toInputUppercase} readOnly={this.state.loading} />
                        </Col>
                    </Row>
                    <Row className="mt-1"><Col className="col-8">Items</Col><Col className="col-4"><Button className="float-right" variant="warning" disabled={this.state.loading} onClick={() => { this.setState({ alertReset: true }) }}>Reset</Button></Col></Row>
                    <Row className="mt-1">
                        <Col className="col-12">
                            {this.state.ssccScannedItemsList.map(function (item, index) {
                                var child = parent;
                                return (<ListGroup.Item key={index}>
                                    <Row>
                                        <Col> {index + 1}</Col>
                                        <Col> {item}</Col>
                                        <Col><Button className="float-right" variant="link" onClick={() => child.removeSSCCItemBarcodesFromList(index)}>Remove</Button></Col>
                                    </Row>
                                </ListGroup.Item>);
                            })}
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col>
                            <Button className="col-6 float-left mt-2" variant="success" disabled={this.state.loading} onClick={() => { this.setState({ toggleSSCCContent: false, ssccScannedItemsList: [], scannedSSCCUnknownCarton: "" }); this.getUnknownCartonsForShipment(); } }>Cancel</Button>
                        </Col>
                        <Col>
                            <Button className="col-6 float-right mt-2" variant="success" disabled={this.state.loading} onClick={() => this.submitUnknownSSCCContent()}>Done</Button>
                        </Col>
                    </Row>

                </>}
                {this.state.unknownCartons.length === 0 && <>
                    <Row>
                        <Col>
                            No more unknown cartons available to scan!!!
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button className="col-12" variant="warning" disabled={this.state.loading} onClick={() => this.goto('SupervisorSignoff', { backUrl: 'CartonisedUnknownCarton', nextUrl: 'CartonisedChooseShipment', selectedShipment: this.state.selectedShipment })}>Supervisor sign-off</Button>
                        </Col>
                    </Row>
                </>}
                <ModalOK title='Error' show={this.state.errorAlert} message={this.state.errorAlertMsg} onClickOk={() => { this.setState({ errorAlert: false, errorAlertMsg: '' }); }}  ></ModalOK>
                <ModalYesNo title="Reset this form?" show={this.state.alertReset} message="Are you sure you want to reset?" onClickNo={(e) => { this.setState({ alertReset: false }) }} onClickYes={() => { this.setState({ alertReset: false, ssccScannedItemsList: [], scannedSSCCUnknownCarton: "" });  }}></ModalYesNo>

            </>
        );
    }

    addSSCCItemBarcodesToList(barcode) {
        var items = this.state.ssccScannedItemsList;
        items.push(barcode);
        this.setState({ ssccScannedItemsList: items });
    }

    removeSSCCItemBarcodesFromList(index) {
        var array = this.state.ssccScannedItemsList; // make a separate copy of the array
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ ssccScannedItemsList: array });
        }
    }

    findUnknownCarton() {
        var searchText = this.state.scannedSSCCUnknownCarton;
        var scannedSSCCUKCarton = null;
        this.setState({ scanMessage: "Invaid SSCC Carton." });
        this.state.unknownCartons.filter(function (item) {
            if (item.sscc === searchText) {
                scannedSSCCUKCarton = item;
            }
        });
        if (scannedSSCCUKCarton !== null) {
            this.setState({ toggleSSCCContent: true, selectedSSCCForItemScan: scannedSSCCUKCarton.sscc });
        }
        else {
            MySound.play(MySound.Sound.stop);
            this.setState({ errorAlert: true, errorAlertMsg: "Invalid SSCC Carton." });
        }
    }

    async getUnknownCartonsForShipment() {
        this.setState({ loading: true });
        fetch(`api/CartonisedInwards/GetUnknownCartons?shipmentRef=${this.state.selectedShipment.shipment_ref}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, unknownCartons: result.data, filteredUnknownCartons: result.data, alertMessage: "" });
                        if (result.data.length === 0) {
                            this.goto('CartonisedSupervisorSignoff', { backUrl: 'CartonisedUnknownCarton', nextUrl: 'CartonisedChooseShipment', selectedShipment: this.state.selectedShipment });
                        }
                    }
                    else {
                        this.setState({ alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    async submitUnknownSSCCContent() {
        let userID = MyGlobal.user;
        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ SelectedShipmentId: this.state.selectedShipment.shipment_ref, UnknownSSCC: this.state.selectedSSCCForItemScan, CartonContent: this.state.ssccScannedItemsList, Action: "ADDCONTENT", LoggedInUser: userID, })
        };
        fetch('api/CartonisedInwards/SubmitUnknownCartonContent', submitRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = response.statusText;
                    this.setState({ alertMessage: result.errorMessage, loading: false });
                }
                else {
                    if (result.success) {
                        MySound.play(MySound.Sound.next);
                        this.setState({ toggleSSCCContent: false, ssccScannedItemsList: [] });
                        this.getUnknownCartonsForShipment();
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: "OOOps an error occurred. Please try again!!!" });
            });



    }
}
export default CartonisedUnknownCarton;

